import React from 'react';
import { gettext } from '@adjust/dashboard-core/lib/utils/localization';

import { getPartnerAdAccountsUrl } from '@lib/utils/url';
import { PartnerAdAccountsCount } from '@api/types';
import { TileWithLoading } from '@react/Pages/AccountSettingsPage/YourDataSection/TileWithLoading';
import { PartnerAdAccountLink } from './PartnerAdAccountLink';

import './PartnerAdAccountsTile.scss';

const adAccounts = [
  {
    id: 'twitter',
    name: gettext('label.twitter'),
    href: getPartnerAdAccountsUrl('/twitter'),
  },
  {
    id: 'facebook',
    name: gettext('label.facebook'),
    href: getPartnerAdAccountsUrl('/facebook'),
  },
  {
    id: 'google',
    name: gettext('label.google'),
    href: getPartnerAdAccountsUrl('/google'),
  },
];

interface PartnerAdAccountsTileProps {
  href: string;
  partnerAdAccountsCount: PartnerAdAccountsCount;
}

const PartnerAdAccountsTileBase: React.FC<PartnerAdAccountsTileProps> = ({ href, partnerAdAccountsCount }) => (
  <>
    <div className="your-data-card__title">{t('title.partner-ad-accounts')}</div>
    <div className="your-data-card__body your-data-card__body--centered">
      <div className="flex-one flex-box-row partner-ad-accounts-container">
        {adAccounts.map(adAccount => (
          <div className="flex-one" key={adAccount.id}>
            <PartnerAdAccountLink count={partnerAdAccountsCount[adAccount.id]} {...adAccount} />
          </div>
        ))}
      </div>
    </div>
    <a className="your-data-card__action" href={href}>
      <i className="icon-show" />
    </a>
  </>
);

export const PartnerAdAccountsTile = TileWithLoading(PartnerAdAccountsTileBase);
